import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/';

export const CHANGE_VOUCHER_CODE = NS + 'CHANGE_VOUCHER_CODE';
export const CHANGE_VOUCHER_TABLE_DATA = NS + 'CHANGE_VOUCHER_TABLE_DATA';
export const REQUEST_VOUCHER_TABLE_DATA = NS + 'REQUEST_VOUCHER_TABLE_DATA';
export const ERROR_VOUCHER_TABLE_DATA = NS + 'ERROR_VOUCHER_TABLE_DATA';

export const VOUCHER_TABLE = 'voucherTable'



// WEBPACK FOOTER //
// ./src/modules/voucher/state/search/type.js